import React, { useState } from "react";
import { useParams, useNavigate, useLocation } from "react-router-dom";
import {
    Layout,
    Button,
    Space,
    Typography,
    Collapse,
} from "antd";
import DeviceDetailsCard from "../components/devicemanagement/devicedetailscard";
import DeviceScreenshotsCard from "../components/devicemanagement/devicescreenshotscard";
import ScreenshotButton from "../components/devicemanagement/screenshotbutton";
import ViewAppsButton from "../components/devicemanagement/viewappsbutton";
import RebootButton from "../components/devicemanagement/rebootbutton";

const { Header } = Layout;
const { Title } = Typography;
const { Panel } = Collapse;

const DeviceDetailsPage: React.FC = () => {
    const { deviceId } = useParams<{ deviceId: string }>();
    const navigate = useNavigate();
    const location = useLocation();
    const aliasName = (location.state as { aliasName?: string })?.aliasName;

    const [screenshotsPanelOpen, setScreenshotsPanelOpen] = useState(false);
    const [screenshotsRefreshKey, setScreenshotsRefreshKey] = useState(0);

    return (
        <div style={{ padding: 24 }}>
            {/* Header with actions */}
            <Header style={{ background: "#fff", padding: "12px 24px", marginBottom: 16 }}>
                <Space style={{ width: "100%", justifyContent: "space-between" }}>
                    <Space>
                        <Title level={3} style={{ margin: 0 }}>
                            {aliasName}
                        </Title>
                        <Button
                            color="primary"
                            variant="filled"
                            onClick={() => navigate("/devices")}
                            style={{ marginLeft: 16 }}
                        >
                            Go to Devices
                        </Button>
                    </Space>
                    <Space>
                        <ViewAppsButton deviceId={deviceId!} aliasName={aliasName} />

                        <ScreenshotButton
                            deviceId={deviceId!}
                            aliasName={aliasName}
                            onScreenshotTaken={() => {
                                // wait 5 seconds before refreshing, so API has time to process
                                setTimeout(() => {
                                    setScreenshotsRefreshKey(prev => prev + 1);
                                }, 5000);
                            }}
                        />
                        <RebootButton deviceId={deviceId!} aliasName={aliasName} />
                    </Space>
                </Space>
            </Header>

            <Collapse
                accordion
                defaultActiveKey={["details"]}
                onChange={(keys) => {
                    setScreenshotsPanelOpen(keys.includes("screenshots"));
                }}
            >
                <Panel header="Device Details" key="details">
                    <DeviceDetailsCard deviceId={deviceId!} />
                </Panel>

                <Panel header="Screenshots" key="screenshots">
                    <DeviceScreenshotsCard
                        deviceId={deviceId!}
                        triggerLoad={screenshotsPanelOpen}
                        refreshKey={screenshotsRefreshKey}
                    />
                </Panel>
            </Collapse>
        </div>
    );
};

export default DeviceDetailsPage;